import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button,
  TextField,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import validate from 'validate.js';

import { useSelector, useDispatch } from "react-redux";
import { changePassword, setAlertChangePassword } from "../../../../redux/reducers/appReducer";

validate.validators.password = function(value, options, key, attributes) {

  const regex = /.*([a-z]+[A-Z]+[0-9]+|[a-z]+[0-9]+[A-Z]+|[A-Z]+[a-z]+[0-9]+|[A-Z]+[0-9]+[a-z]+|[0-9]+[a-z]+[A-Z]+|[0-9]+[A-Z]+[a-z]+).*/;
  if (!regex.test(value) || value.length < 8) return "^Минимум 8 символов в разных регистрах a-Z и цифры 0-9";

};

const schema = {
  currentPassword: {

    presence: { allowEmpty: false, message: '^Введите пароль' }

  },
  password: {

    presence: { allowEmpty: false, message: '^Введите пароль' },
    password: true
    // length: {
    //   minimum: 8,
    //   tooShort: "^Минимальная длина пароля 8 символов",
    //   maximum: 128
    // }
  },
  confirmpassword: {
    presence: { allowEmpty: false, message: '^Введите подтверждение пароля' },
    equality: {
      attribute: "password",
      message: '^Пароли не совпадают'
    }
  }
};

const useStyles = makeStyles(() => ({
  root: {}
}));

const Password = props => {
  const { className, ...rest } = props;

  const dispatch = useDispatch();
  const { changePasswordAlert } = useSelector(state => state.appReducer);

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleUpdate = event => {
    event.preventDefault();

    const currentPassword = formState.values.currentPassword;
    const newPassword = formState.values.password;
    dispatch(changePassword(currentPassword, newPassword));
    setFormState({
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    });

  };


  const hasError = field => formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form>
        <CardHeader
          title="Изменить пароль"
        />
        <Divider />
        <CardContent>
          <TextField
            fullWidth
            label="Текущий пароль"
            type="password"
            variant="outlined"

            name="currentPassword"
            value={formState.values.currentPassword || ''}
            onChange={handleChange}
            error={hasError('currentPassword')}
            helperText={hasError('currentPassword') ? formState.errors.currentPassword[0] : null}
          />
          <TextField
            fullWidth
            label="Новый пароль"
            style={{ marginTop: '1rem' }}
            type="password"
            variant="outlined"
            name="password"
            value={formState.values.password || ''}
            onChange={handleChange}
            error={hasError('password')}
            helperText={hasError('password') ? formState.errors.password[0] : null}
          />
          <TextField
            fullWidth
            label="Подтверждение пароля"
            style={{ marginTop: '1rem' }}
            type="password"
            variant="outlined"
            name="confirmpassword"
            value={formState.values.confirmpassword || ''}
            onChange={handleChange}
            error={hasError('confirmpassword')}
            helperText={hasError('confirmpassword') ? formState.errors.confirmpassword[0] : null}
          />
        </CardContent>
        <Divider />
        <CardActions>

          {changePasswordAlert
            ? <Alert 
                severity={changePasswordAlert==="OK"?"success":"error"}
                onClose={() => { dispatch(setAlertChangePassword(undefined)) }}>
                  {changePasswordAlert==="OK"?"Пароль изменен.":changePasswordAlert}
              </Alert>
            : <Button
                color="primary"
                variant="outlined"
                disabled={!formState.isValid}
                onClick={handleUpdate}
              >
                Изменить
            </Button>
          }

        </CardActions>
      </form>
    </Card>
  );
};

Password.propTypes = {
  className: PropTypes.string
};

export default Password;
